export default function ({ app }) {
  app.$moment.locale(app.i18n.locale)
  
  app.i18n.beforeLanguageSwitch = (_, newLocale) => {
    app.$moment.locale(newLocale)
  }
}
